export const getSelectedFolder = state => state.folders.explodedItems[state.application.selectedFolderId];
export const getShowMoveFolderAlert = state => state.folders.showMoveFolderAlert;
export const getFirstSyncCompleted = state => state.folders.firstSyncCompleted;
